import { useState } from 'react';
import { Select } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useUpdateEntry } from '../../../queries/runsheet-entries';
import { useDocumentTypes } from '../../../queries/document-types';
import { ApiError } from '../../../lib/api-error';
import type { RunsheetEntry } from '../../../types/api';

interface Props {
  entry: RunsheetEntry;
}

export function InlineCellDocType({ entry }: Props) {
  const { data: docTypes = [] } = useDocumentTypes();
  const updateM = useUpdateEntry();
  const server = entry.document_type_id;
  const [value, setValue] = useState<string | null>(server);
  const [lastServer, setLastServer] = useState<string | null>(server);

  if (lastServer !== server) {
    setLastServer(server);
    setValue(server);
  }

  async function commit(next: string | null) {
    if (next === entry.document_type_id) return;
    try {
      await updateM.mutateAsync({ id: entry.id, patch: { document_type_id: next } });
    } catch (err) {
      setValue(entry.document_type_id);
      notifications.show({
        color: 'red',
        title: 'Update failed',
        message: err instanceof ApiError ? err.message : 'Retry?',
      });
    }
  }

  return (
    <span data-inline-editor onClick={(e) => e.stopPropagation()}>
      <Select
        size="xs"
        variant="unstyled"
        placeholder="—"
        searchable
        clearable
        data={docTypes.map((t) => ({ value: t.id, label: `${t.code}` }))}
        value={value ?? null}
        onChange={(v) => {
          setValue(v);
          void commit(v);
        }}
        className="rt-inline-edit-cell"
        styles={{ input: { minHeight: 28, padding: '2px 6px' } }}
        comboboxProps={{ width: 260 }}
      />
    </span>
  );
}
